/**
 * Compara duas versões no formato semver (`major.minor.patch`).
 *
 * Retorna um número positivo quando `a` é mais nova que `b`, negativo quando é
 * mais antiga e `0` quando são equivalentes. Valores ausentes ou malformados
 * são tratados como `0.0.0` — é assim que um usuário que nunca viu nenhuma
 * release note acaba recebendo o modal na primeira entrada.
 */
export function compareVersions(a?: string, b?: string): number {
  const parse = (version?: string): number[] => {
    const parts = String(version || '')
      .trim()
      .split('.')
      .map((part) => {
        const parsed = Number.parseInt(part, 10);

        return Number.isNaN(parsed) ? 0 : parsed;
      });

    // Normaliza para 3 posições para que "1.1" e "1.1.0" sejam equivalentes.
    return [parts[0] || 0, parts[1] || 0, parts[2] || 0];
  };

  const versionA = parse(a);
  const versionB = parse(b);

  for (let index = 0; index < 3; index += 1) {
    if (versionA[index] !== versionB[index]) {
      return versionA[index] - versionB[index];
    }
  }

  return 0;
}
